function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3fd2c7",
      fillOpacity: 1
    },
    d: "M 15.011719 6.273438 C 10.214844 6.273438 6.3125 10.179688 6.3125 14.976562 C 6.3125 16.648438 6.789062 18.269531 7.6875 19.667969 L 7.902344 20.003906 L 7.058594 23.011719 L 10.167969 22.210938 L 10.488281 22.40625 C 11.847656 23.238281 13.410156 23.675781 15.011719 23.675781 C 19.8125 23.675781 23.714844 19.773438 23.714844 14.976562 C 23.714844 10.179688 19.8125 6.273438 15.011719 6.273438 Z M 20.347656 17.648438 L 20.238281 18.15625 C 20.117188 18.726562 19.777344 19.234375 19.285156 19.550781 C 18.664062 19.949219 17.855469 20.144531 16.832031 19.851562 C 13.648438 18.953125 11.851562 16.847656 10.882812 15.53125 C 9.917969 14.214844 9.546875 12.898438 9.789062 11.820312 C 9.949219 11.101562 10.476562 10.546875 10.804688 10.261719 C 10.96875 10.121094 11.175781 10.050781 11.390625 10.0625 L 12.070312 10.097656 C 12.203125 10.105469 12.320312 10.1875 12.375 10.3125 L 13.367188 12.628906 C 13.417969 12.753906 13.394531 12.894531 13.308594 12.996094 L 12.445312 13.996094 C 12.375 14.074219 12.363281 14.191406 12.414062 14.285156 C 13.546875 16.472656 15.617188 17.339844 16.234375 17.558594 C 16.339844 17.59375 16.457031 17.558594 16.527344 17.46875 L 17.425781 16.300781 C 17.527344 16.171875 17.703125 16.128906 17.855469 16.195312 L 20.152344 17.253906 C 20.300781 17.324219 20.382812 17.488281 20.347656 17.648438 Z M 20.347656 17.648438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3fd2c7",
      fillOpacity: 1
    },
    d: "M 0 0 L 0 30 L 30 30 L 30 0 Z M 15.011719 25.453125 C 13.214844 25.453125 11.449219 24.992188 9.890625 24.117188 L 4.507812 25.503906 L 5.976562 20.285156 C 5.035156 18.679688 4.535156 16.851562 4.535156 14.976562 C 4.535156 9.199219 9.234375 4.496094 15.011719 4.496094 C 20.789062 4.496094 25.492188 9.199219 25.492188 14.976562 C 25.492188 20.753906 20.789062 25.453125 15.011719 25.453125 Z M 15.011719 25.453125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappFooter);
export default __webpack_public_path__ + "static/media/whatsapp_footer.0f2ddb113601ebac32327d54c6e975a5.svg";
export { ForwardRef as ReactComponent };